import { useEffect, useState } from 'react';
import { Download } from 'lucide-react';
import { Button } from '../../../../components/ui/atoms/button';
import { Input } from '../../../../components/ui/atoms/input';
import { Label } from '../../../../components/ui/atoms/label';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from '../../../../components/ui/organisms/dialog';

/** Asks for the client name written into the Customer Timesheet's "Client Name" row. */
export function ClientNameDialog({
  open, onOpenChange, defaultValue, onConfirm, isExporting,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Prefill — the filtered project's client, when exactly one project is selected. */
  defaultValue: string;
  onConfirm: (clientName: string) => void;
  isExporting: boolean;
}) {
  const [clientName, setClientName] = useState(defaultValue);

  // Re-seed on every open so a previous run's value doesn't leak into the next.
  useEffect(() => {
    if (open) setClientName(defaultValue);
  }, [open, defaultValue]);

  const submit = () => onConfirm(clientName.trim());

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Client name</DialogTitle>
        </DialogHeader>

        <form
          className="space-y-4"
          onSubmit={(e) => { e.preventDefault(); submit(); }}
        >
          <div className="space-y-2">
            <Label htmlFor="timesheet-client-name">Client Name</Label>
            <Input
              id="timesheet-client-name"
              placeholder="e.g. Acme Corp"
              value={clientName}
              onChange={(e) => setClientName(e.target.value)}
              autoFocus
            />
            <p className="text-xs text-muted-foreground">
              Shown on every employee sheet. Leave blank to keep the field empty.
            </p>
          </div>

          <div className="flex justify-end gap-2 pt-2">
            <Button type="button" variant="ghost" size="sm" onClick={() => onOpenChange(false)} disabled={isExporting}>
              Cancel
            </Button>
            <Button type="submit" size="sm" disabled={isExporting} className="gap-2">
              <Download className="h-4 w-4" />
              {isExporting ? 'Exporting…' : 'Export'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
